<template slot-scope="scope">
  <div class="city-picker">
    <van-picker show-toolbar :title="title" :columns="columns" @confirm="confirm" @cancel="cancel" />
  </div>
</template>

<script>
import config from '@/configs/config'

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '请选择城市'
    },
    column: {
      type: Number,
      default: 3
    },
    confirm: {
      type: Function
    },
    cancel: {
      type: Function
    },
    formatvalue: {
      type: Function
    }
  },
  data() {
    return {
      columns: []
    }
  },
  mounted() {
    const proviceList = tuhu.localStorage.getItem('proviceList')
    if (proviceList) {
      const proviceListAreaNo = JSON.parse(proviceList)
      if (proviceListAreaNo && proviceListAreaNo[0] && proviceListAreaNo[0].areaNo) {
        this.initCityPicker(JSON.parse(proviceList))
      } else {
        tuhu.localStorage.removeItem('proviceList')
        this.getCityList()
      }
    } else {
      this.getCityList()
    }
  },
  methods: {
    async getCityList() {
      try {
        const res = await tuhu.fetch(`${config.apis.PROVINCE}`)
        if (res && res.code === '200') {
          const transformTree = data => {
            return data.map(item => ({
              id: item.id,
              name: item.areaName,
              areaNo: item.areaNo,
              children: item.children ? transformTree(item.children) : undefined
            }))
          }
          const r1 = transformTree(res.data)
          const r2 = this.replace(r1)
          tuhu.localStorage.setItem('proviceList', JSON.stringify(r2))
          this.initCityPicker(r2)
        } else {
          tuhu.toast(res.message || '城市列表获取错误')
          console.log(`${config.apis.PROVINCE}`, res)
        }
      } catch (e) {
        console.log(`${config.apis.PROVINCE}`, e)
      }
    },
    // 格式化数据
    initCityPicker(cityList) {
      this.columns = cityList
      // 格式化格式化以后的数据
      // let pArr = []
      // // 格式化省市区信息
      // cityList.map(pItem => {
      //     // 添加省列表
      //     let pList = {
      //         text: pItem.ProviceName,
      //         pcNo: pItem.pcNo,
      //         children: []
      //     }
      //     pArr.push(pList)

      //     // 市
      //     pItem.CityList.map(cItem => {
      //         // 添加市列表
      //         let cList = {
      //             text: cItem.CityName,
      //             pcNo: cItem.pcNo,
      //             children: []
      //         }
      //         pList.children.push(cList)

      //         // 区
      //         if (cItem.AreaList) { // 没有县
      //             cItem.AreaList.map(aItem => {
      //                 // 添加区列表
      //                 let aList = {
      //                     pcNo: aItem.pcNo,
      //                     text: aItem.CityName
      //                 }
      //                 cList.children.push(aList)
      //             })
      //         }
      //     })
      // })
      // console.log('pArr', pArr)
      // this.columns = pArr
    },
    // 格式化城市信息
    groupby(list, key) {
      const map = {}
      list.forEach(item => {
        const index = item[key]
        if (!map[index]) map[index] = []

        map[index].push(item)
      })

      return map
    },
    transfer(groups, parentId) {
      const list = groups[parentId]
      const res = []
      if (!list) return []

      for (let item of list) {
        const route = {
          id: item.id,
          name: item.pcName,
          areaNo: item.areaNo
        }

        const children = this.transfer(groups, item.id)
        if (children && children.length) {
          route.children = children
        }

        res.push(route)
      }
      return res
    },
    replace(menus) {
      const fields = [
        {
          name: 'text',
          id: 'RegionID',
          areaNo: 'areaNo',
          children: 'children'
        },
        {
          name: 'text',
          id: 'RegionID',
          areaNo: 'areaNo',
          children: 'children'
        },
        {
          name: 'text',
          id: 'RegionID',
          areaNo: 'areaNo',
          children: ''
        }
      ]
      const r = (menus, index) => {
        const field = fields[index]
        ++index
        if (!field) return
        const arr = []
        for (let v of menus) {
          const item = {
            [field.id]: v.id,
            [field.name]: v.name,
            [field.areaNo]: v.areaNo
          }
          // 过滤
          // if (['上海市', '北京市', '天津市', '重庆市'].indexOf(v.name) > -1) { // 不用了
          if ([].indexOf(v.name) > -1) {
            let res = []
            v.children.forEach(item => {
              res.push({
                RegionID: item.id,
                CityName: item.name,
                areaNo: item.areaNo
              })
            })
            Object.assign(item, {
              CityList: [
                {
                  CityName: v.name,
                  RegionID: v.id,
                  areaNo: v.areaNo,
                  AreaList: res
                }
              ]
            })
          } else {
            if (v.children && v.children.length) {
              field.children && (item[field.children] = r(v.children, index))
            }
          }
          arr.push(item)
        }
        return arr
      }
      return r(menus, 0)
    },
    // this.$refs.xxx.cityData(iArr)
    // 父组件confirm中调用 params：选中的indexList [0, 1, 1]
    cityData(iArr) {
      let index = iArr
      let pData = this.columns[index[0]]
      let cData = this.columns[index[0]].children[index[1]] || ''
      let dData = this.columns[index[0]].children[index[1]].children[index[2]] || ''
      let city = {
        provinceId: pData.areaNo,
        cityId: cData.areaNo,
        districtId: dData.areaNo
      }
      return city
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cityPicker.vue